<template>
  <div :id="`order_${order.id}`" class="z-border-red" style="margin-bottom: 10px">
    <v-layout>
      <v-flex>
        <div class="ma-2">
          <v-checkbox
            :input-value="isCheck"
            :label="`Order No. ${order.id}`"
            style="display: inline-block"
            class="ma-0"
            color="primary"
            hide-details
            @change="assignCb(order.id)"
          ></v-checkbox>

          <v-chip
            v-if="
              selectedBot.theme == 'nvbb' && status && status.label && status.value == 'ordered'
            "
            style="vertical-align: top"
            color="red"
            small
            disabled
            class="white--text"
            >{{ status.label }}</v-chip
          >
          <span
            v-if="selectedBot.theme == 'runkan' && order.runkanstatus"
            style="position: relative; bottom: 8px"
            ><v-chip
              dark
              small
              dense
              :color="order.runkanstatus == 'SUCCESS' ? 'success' : 'grey'"
              >{{ order.runkanstatus == 'SUCCESS' ? 'วิ่งสำเร็จ' : 'วิ่งไม่สำเร็จ' }}</v-chip
            ></span
          >
        </div>
      </v-flex>
      <v-flex>
        <div class="ma-2" style="display: flex; justify-content: end; align-items: center">
          <v-btn
            icon
            outline
            small
            color="primary"
            class="m-0"
            @click.stop="goToLivechat(order, order.app)"
          >
            <em class="fas fa-comments" />
          </v-btn>
          <template v-if="order.app == 'facebook'">
            <em class="fab fa-facebook-square" style="color: #3c5a99; font-size: 25px" />
          </template>
          <template v-else-if="order.app == 'line'">
            <em class="fab fa-line" style="color: #00c300; font-size: 25px" />
          </template>
        </div>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
    <v-layout wrap fill-height>
      <v-flex xs12 sm7>
        <div style="border-right: 1px solid #eee; height: 100%">
          <template v-if="typeof orderDetailFormat == 'string'">
            <div class="pa-2">
              <nl2br tag="div" :text="order.productdetail"></nl2br>
            </div>
          </template>
          <template v-else-if="typeof orderDetailFormat == 'object'">
            <template v-for="(product, oindex) in orderDetailFormat">
              <template
                v-if="
                  !['740558886346101'].includes(selectedBot.pageid) ||
                  (['740558886346101'].includes(selectedBot.pageid) &&
                    (oindex < 3 || showProductDetail == order.id))
                "
              >
                <v-layout :key="'order_' + oindex" wrap>
                  <v-flex sm1 xs2>
                    <div class="ma-2">
                      <v-img :src="product.photourl" aspect-ratio="1" alt class="grey lighten-2">
                        <template #placeholder>
                          <v-layout fill-height align-center justify-center ma-0>
                            <!-- <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular> -->
                          </v-layout>
                        </template>
                      </v-img>
                    </div>
                  </v-flex>
                  <v-flex sm7 xs6 style="word-break: break-word">
                    <div class="ma-2">
                      {{ product.name }} x {{ product.quantity }}
                      <template v-if="product.option">({{ product.option }})</template>
                    </div>
                  </v-flex>
                  <v-flex xs4 class="text-xs-right">
                    <div class="ma-2">฿{{ product.price | decimalFormat }}</div>
                  </v-flex>
                </v-layout>
                <v-divider v-if="oindex < orderDetailFormat.length - 1" :key="oindex"></v-divider>
              </template>
            </template>
            <template
              v-if="
                ['740558886346101'].includes(selectedBot.pageid) && orderDetailFormat.length > 3
              "
            >
              <v-btn
                style="width: 100%"
                class="ma-0"
                depressed
                color="primary lighten-3"
                small
                @click="
                  $emit('onShowProductDetail', showProductDetail == order.id ? null : order.id)
                "
              >
                {{
                  $t(showProductDetail == order.id ? 'Show less products' : 'Show more products')
                }}
                ({{ orderDetailFormat.length }})
                <v-icon>{{ showProductDetail == order.id ? 'expand_less' : 'expand_more' }}</v-icon>
              </v-btn>
            </template>
          </template>

          <div>
            <v-layout v-if="order.total != null">
              <v-flex>
                <div class="pa-2">{{ $t('Subtotal') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color"
                    >฿{{
                      (order.total - (order.shippingcharge ? order.shippingcharge : 0))
                        | decimalFormat
                    }}</span
                  >
                </div>
              </v-flex>
            </v-layout>
            <v-layout v-if="order.shippingcharge != null">
              <v-flex>
                <div class="pa-2">{{ $t('Shipping fee') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">฿{{ order.shippingcharge | decimalFormat }}</span>
                </div>
              </v-flex>
            </v-layout>
            <v-layout v-if="order.discount > 0">
              <v-flex>
                <div class="pa-2">{{ $t('Discount') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">-฿{{ order.discount | decimalFormat }}</span>
                </div>
              </v-flex>
            </v-layout>

            <v-layout v-if="jsonValue != null && jsonValue.promocode">
              <v-flex>
                <div class="pa-2">{{ $t('Coupon Code') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">{{ jsonValue.promocode }}</span>
                </div>
              </v-flex>
            </v-layout>

            <v-layout v-if="order.amount != null">
              <v-flex>
                <div class="pa-2">{{ $t('Total') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">฿{{ order.amount | decimalFormat }}</span>
                </div>
              </v-flex>
            </v-layout>
          </div>

          <v-btn
            v-if="selectedBot.theme == 'nvbb' && ['paid', 'shipped'].includes(order.status)"
            small
            color="primary"
            outline
            @click="moveToPreorder(order)"
          >
            ย้ายสินค้าไป preorder
          </v-btn>
          <v-divider />
          <template v-if="!['lookchingiant'].includes(selectedBot.theme)">
            <div v-if="['dtac-gaming'].includes(selectedBot.type)" class="pa-2">
              <v-layout wrap>
                <v-flex xs12>อัพโหลดใบเสร็จ</v-flex>
                <v-flex xs9 class="py-2">
                  <uploadfile v-model="order.note" :height="250"></uploadfile>
                </v-flex>
                <v-flex
                  xs3
                  style="
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    justify-content: center;
                  "
                  class="pl-2"
                >
                  <v-btn color="primary" class="mb-3" @click="handleUploadedReceipt">Upload</v-btn>
                  <v-btn
                    color="primary"
                    :disabled="order.note ? false : true"
                    @click="handleSendReceipt"
                    >Send</v-btn
                  >
                </v-flex>
              </v-layout>
            </div>
            <template v-else>
              <v-layout>
                <v-flex class="pa-2">
                  <img
                    v-if="shippingType == 'normal'"
                    src="/static/img/assets/payment/normal_charge_logo.png"
                    alt
                    class="responsive-img"
                    style="max-height: 50px"
                  />
                  <img
                    v-else-if="shippingType == 'ems'"
                    src="/static/img/assets/payment/ems_charge_logo.png"
                    alt
                    class="responsive-img"
                    style="max-height: 50px"
                  />
                  <img
                    v-else-if="shippingType == 'kerry'"
                    src="/static/img/assets/payment/kerry_charge_logo.png"
                    alt
                    class="responsive-img"
                    style="max-height: 50px"
                  />
                  <template v-else>
                    <template v-if="shippingType">
                      <img
                        :src="'/static/img/assets/payment/' + shippingType + '_logo.png'"
                        alt
                        class="responsive-img"
                        style="max-height: 50px"
                        @error="onImageLoadFailure($event)"
                      />
                      <div v-if="shippingType == 'cod_charge'" class="caption">
                        {{ $t('cod_charge') }}
                      </div>
                    </template>
                  </template>
                </v-flex>
                <v-flex class="pa-2 text-xs-right">
                  <multiselect
                    v-model="shippingValue"
                    :options="shippingOptions"
                    label="name"
                    select-label
                    selected-label
                    :allow-empty="false"
                    :searchable="false"
                    deselect-label
                    track-by="name"
                    @select="onSelectShipping"
                  >
                    <template slot="singleLabel" slot-scope="props">
                      <span class="option__title">
                        <template v-if="props.option.name && props.option.name.includes('other')">{{
                          props.option[4]
                        }}</template>
                        <template v-else>{{ $t(props.option.name) }}</template>
                      </span>
                    </template>
                    <template slot="option" slot-scope="props">
                      <div>
                        <span class="option__title">
                          <template
                            v-if="props.option.name && props.option.name.includes('other')"
                            >{{ props.option[4] }}</template
                          >
                          <template v-else>{{ $t(props.option.name) }}</template>
                        </span>
                      </div>
                    </template>
                  </multiselect>
                  <!-- <v-layout justify-center align-center style="height: 100%" row>
                <v-flex>
                  <template v-if="shippingType.includes('other')">{{ shippingValue }}</template>
                  <template v-else>{{ $t(shippingType) }}</template>
                </v-flex>
              </v-layout> -->
                </v-flex>
              </v-layout>
            </template>
            <v-divider />
          </template>
          <v-layout wrap>
            <v-flex v-if="['cityfresh'].includes(selectedBot.theme)" xs12 class="pa-2">
              <CityFreshShippingDate
                :shipping-date="order.shipping_date"
                :shipping-time="order.shipping_time"
                @edited="onCityfreshUpdateShippingdate"
              ></CityFreshShippingDate>
            </v-flex>
            <v-flex v-if="showSetShippingDateTime" xs12 class="pa-2">
              <SetShippingDatetime
                :shipping-date="order.shipping_date"
                :is-date-time="isTremendous ? false : true"
                @edited="onUpdateShippingdate"
              ></SetShippingDatetime>
            </v-flex>
            <v-flex class="pa-2">
              <div class="caption">
                <template v-if="$store.state.centralPage.includes(selectedBot.pageid)"
                  >หมายเลขเดอะวัน</template
                >
                <template v-else>{{ $t('Remark') }}</template>
              </div>
              <editable
                v-model="order.remark"
                :filter="'text'"
                :type="'textarea'"
                @edited="$emit('updateOrder', 'save')"
              ></editable>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <v-flex xs12 sm5>
        <div style="word-break: break-word" class="pa-2">
          <a target="_BLANK" :href="`https://business.facebook.com${order.inboxurl}`"
            >{{ order.first_name }} {{ order.last_name }}
            <span v-if="['dtac-gaming'].includes(selectedBot.type)">({{ order.userid }})</span>
          </a>

          <template
            v-if="
              selectedBot.pageid == '103012211224246' ||
              selectedBot.pageid == '635426456938760' ||
              selectedBot.pageid == '613259679129221' ||
              selectedBot.pageid == '101857778024677'
            "
          >
            <template v-if="typeof shippingAddressPosition == 'string'">
              <edit-address
                v-if="order.nameaddress"
                v-model="order.nameaddress"
                :has-copy="true"
                @edited="$emit('updateOrder', 'save')"
              ></edit-address>
            </template>
            <template v-else>
              <a
                :href="`https://maps.google.com?q=${shippingAddressPosition.lat},${shippingAddressPosition.lng}`"
                target="_blank"
                style="word-break: break-word"
              >
                https://maps.google.com?q={{
                  `${shippingAddressPosition.lat},${shippingAddressPosition.lng}`
                }}
              </a>
            </template>
          </template>
          <template v-else>
            <edit-address
              v-if="order.nameaddress"
              v-model="order.nameaddress"
              :type="'textarea'"
              :has-copy="true"
              @edited="$emit('updateOrder', 'save')"
            ></edit-address>
          </template>
          <template
            v-if="$store.state.nestlePages.some((page) => page.pageid == selectedBot.pageid)"
          >
            <div class="caption mt-3">{{ $t('Email') }}</div>
            <div class="primary--text">
              {{
                order.shipping_address && order.shipping_address.email
                  ? order.shipping_address.email
                  : '-'
              }}
            </div>
          </template>
          <div class="caption mt-3">{{ $t('Status') }}</div>
          <div class="primary--text">{{ order.userstatus ? order.userstatus : '-' }}</div>
          <template v-if="$store.state.centralPage.includes(selectedBot.pageid)">
            <div class="caption mt-3">{{ $t('Live name') }}</div>
            <div class="primary--text">{{ order.livename ? order.livename : '-' }}</div>
          </template>
          <div class="caption mt-3">
            {{ $t('Tag') }} {{ tags.length > 0 ? ` (${tags.length})` : '' }}
          </div>
          <TagGroup v-model="tags" />
        </div>
        <v-divider></v-divider>
        <div class="pa-2">
          <template v-if="!(['fbpay'].includes(value.payment) && status.value == 'shipped')">
            <template v-if="['foodguru'].includes(selectedBot.theme)">
              <!-- Foodguru -->
              <multiselect
                v-model="status"
                :options="foodguruOrderStatusOptions"
                label="label"
                :allow-empty="false"
                :searchable="false"
                select-label
                selected-label
                deselect-label
                track-by="label"
                @select="onSelectOrderStatus"
              ></multiselect>
            </template>
            <template v-else-if="['dtac-gaming'].includes(selectedBot.type)">
              <multiselect
                v-model="status"
                :options="dtacGamingOrderStatusOptions"
                label="label"
                :allow-empty="false"
                :searchable="false"
                deselect-label
                track-by="label"
                @select="onSelectOrderStatus"
              ></multiselect>
            </template>
            <template v-else>
              <multiselect
                v-model="status"
                :options="orderStatusOptions"
                label="label"
                :allow-empty="false"
                :searchable="false"
                :disabled="['lookchingiant'].includes(selectedBot.theme)"
                select-label
                selected-label
                deselect-label
                track-by="label"
                @select="onSelectOrderStatus"
              ></multiselect>
            </template>
          </template>
          <template v-else>
            <v-layout>
              <v-flex>
                {{ $t('Order status') }}
              </v-flex>
              <v-flex class="text-xs-right primary--text">
                {{ status.label }}
              </v-flex>
            </v-layout>
          </template>

          <template v-if="order.status == 'shipped' || order.status == 'ส่งของสำเร็จ'">
            <div class="form-control pt-2">
              <textarea
                v-model="order.trackingno"
                :disabled="order && order.zortout_ref"
                type="text"
                class="form-control"
                :placeholder="$t('Tracking')"
                maxlength="2000"
              />
            </div>
            <div class="text-xs-center text-sm-right mb-3">
              <v-btn
                outline
                color="primary"
                class="ma-0"
                small
                :disabled="
                  order.trackingno == null ||
                  order.trackingno == '' ||
                  order.trackingno.trim() == ''
                "
                @click="$emit('updateOrder', 'save')"
              >
                <em class="far fa-save" />
                &nbsp;
                {{ $t('Save') }}
              </v-btn>
              <v-btn
                outline
                color="primary"
                class="ma-0"
                small
                :disabled="
                  order.trackingno == null ||
                  order.trackingno == '' ||
                  order.trackingno.trim() == ''
                "
                @click="$emit('updateOrder', 'send')"
              >
                <em class="far fa-share-square" />
                &nbsp;
                {{ $t('Send') }}
              </v-btn>
            </div>
          </template>
          <template v-else-if="order.status == 'canceled'">
            <div class="form-control pt-2">
              <input
                v-model="order.reason"
                type="text"
                class="form-control"
                :placeholder="$t('Reason')"
                maxlength="300"
              />
            </div>
            <div class="text-xs-center text-sm-right mb-3">
              <v-btn
                outline
                color="primary"
                class="ma-0"
                small
                :disabled="order.reason == null || order.reason == '' || order.reason.trim() == ''"
                @click="$emit('updateOrder', 'save')"
              >
                <em class="far fa-save" />
                &nbsp;
                {{ $t('Save') }}
              </v-btn>
              <v-btn
                outline
                color="primary"
                class="ma-0"
                small
                :disabled="order.reason == null || order.reason == '' || order.reason.trim() == ''"
                @click="$emit('updateOrder', 'send')"
              >
                <em class="far fa-share-square" />
                &nbsp;
                {{ $t('Send') }}
              </v-btn>
            </div>
          </template>

          <template v-if="order && order.zortout_ref">
            <div class="pa-2">
              <v-layout>
                <v-flex shrink> Zortout ref. </v-flex>
                <v-flex class="text-xs-right primary--text">
                  {{ order.zortout_ref }}
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex shrink>
                  {{ $t('Tracking') }}
                </v-flex>
                <v-flex class="text-xs-right">
                  {{ order.trackingno }}
                </v-flex>
              </v-layout>
            </div>
            <v-divider />
          </template>
        </div>
        <v-divider />

        <template v-if="['booking', 'waiting', 'confirm'].includes(order.shippop_status)">
          <div class="pa-2">
            <v-layout>
              <v-flex>สถานะการส่งกับ Shippop</v-flex>
              <v-flex shrink class="text-xs-right">
                <v-chip color="blue" disabled class="white--text" small>
                  {{ order.shippop_status }}
                </v-chip>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex shrink> Shippop Tracking no. </v-flex>
              <v-flex class="text-xs-right">
                <a
                  :href="`https://www.shippop.com/tracking/?tracking_code=${order.shippop_tracking_code}`"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ order.shippop_tracking_code }}
                </a>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex shrink>
                {{ $t('Tracking') }}
              </v-flex>
              <v-flex class="text-xs-right">
                {{ order.trackingno }}
              </v-flex>
            </v-layout>
          </div>
          <v-divider />
        </template>

        <v-layout>
          <v-flex>
            <div class="pa-2">
              <div>
                <template v-if="shippingType && shippingType == 'cod_charge'">
                  {{ $t('cod_charge') }}
                </template>
                <template v-else>
                  <template v-if="order.payment == 'banktransfer' || order.payment == 'transfer'">
                    {{ $t('Bank Transfer') }}
                  </template>
                  <template v-else-if="order.payment == 'cod'">{{ $t('cod_charge') }}</template>
                  <template v-else-if="order.payment == 'qrcode'">Qr Code</template>
                  <template v-else-if="order.payment == 'fbpay'">
                    {{ $t('Mobile Banking') }}
                  </template>
                  <template v-else-if="order.payment == 'credit'">{{ $t('PayPal') }}</template>
                  <template v-else-if="order.payment == 'gbcredit'">{{
                    $t('Credit card')
                  }}</template>
                  <template v-else
                    >{{ order.payment }}
                    <span v-if="order.payment == '2c2p' && order.jsonvalue">
                      {{
                        ': ' +
                        (JSON.parse(order.jsonvalue).payment_channel
                          ? JSON.parse(order.jsonvalue).payment_channel
                          : '-')
                      }}
                    </span>
                  </template>
                </template>
                <div v-if="order.transactionid" class="caption">{{ $t(order.transactionid) }}</div>
              </div>
              {{ order.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}
            </div>
          </v-flex>
          <v-flex>
            <div class="pa-2">
              <div style="text-align: right">
                <PrintAllCoversCentral
                  v-if="$store.state.centralPage.includes(selectedBot.pageid)"
                  :orders="[order]"
                  :circle="true"
                  style="display: inline-block"
                  @onPrinCover="onPrinCover(true, $event)"
                ></PrintAllCoversCentral>
                <print-all-covers
                  v-else
                  :orders="[order]"
                  :circle="true"
                  style="display: inline-block"
                  @onPrinCover="onPrinCover(false, $event)"
                ></print-all-covers>
              </div>
            </div>
          </v-flex>
        </v-layout>

        <template v-if="cart_remark">
          <v-divider />
          <div class="pa-2">
            <div
              v-if="
                ['176922345693076', '809510349133469', '103876431747147'].includes(
                  selectedBot.pageid
                )
              "
            >
              ขายโดย
            </div>
            <div class="font-weight-bold primary--text">
              {{ cart_remark }}
            </div>
          </div>
        </template>
      </v-flex>
    </v-layout>
    <template v-if="order.note">
      <div class="hr"></div>
      <a href="javascript:void(0);" style="text-decoration: none" @click="showDetail = !showDetail">
        <div class="text-xs-center" style="margin: 10px auto">
          {{ $t('Click to view slip') }}
          <i class="fas" :class="{ 'fa-chevron-down': showDetail, 'fa-chevron-up': !showDetail }" />
        </div>
      </a>
      <div
        v-show="showDetail"
        style="margin-bottom: 0; background: rgb(253, 253, 253); border-bottom-left-radius: 10px"
      >
        <template v-if="showDetail">
          <template v-if="order.note == 'base64'">
            <load-base64 :key="'slip_' + order.id" :orderid="order.id"></load-base64>
          </template>
          <template v-else-if="order.note">
            <editable
              v-model="order.note"
              :filter="'image'"
              :type="'image'"
              @edited="$emit('updateOrder', 'save')"
            ></editable>
          </template>
        </template>
      </div>
    </template>

    <v-dialog v-model="showMoveToOrder" persistent>
      <v-card>
        <div class="text-xs-right">
          <v-btn small fab flat :loading="nvbb.loading" @click="cancelMoveTo">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text v-if="orderToMove">
          <v-layout wrap>
            <v-flex xs6 style="border-right: 1px solid #eee">
              <template v-for="(product, oindex) in orderToMove.productdetail">
                <v-layout :key="'order_' + oindex" wrap>
                  <v-flex sm1 xs2>
                    <div class="ma-2">
                      <v-img :src="product.photourl" aspect-ratio="1" alt class="grey lighten-2">
                        <template #placeholder>
                          <v-layout fill-height align-center justify-center ma-0>
                            <!-- <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular> -->
                          </v-layout>
                        </template>
                      </v-img>
                    </div>
                  </v-flex>
                  <v-flex sm11 xs10 style="word-break: break-word">
                    <div class="ma-2">
                      {{ product.name }} x {{ product.quantity }}
                      <template v-if="product.option">({{ product.option }})</template>
                    </div>
                  </v-flex>
                </v-layout>
                <v-divider v-if="oindex < orderDetailFormat.length - 1" :key="oindex"></v-divider>
              </template>
            </v-flex>
            <v-flex xs6 class="pl-2 default-input">
              <v-radio-group
                v-model="nvbb.shippingType"
                v-validate="'required'"
                name="shippingtype"
                :error="errors.has('shippingtype') ? true : false"
                :error-messages="errors.has('shippingtype') ? errors.first('shippingtype') : ''"
              >
                <v-radio class="mb-3" color="primary" value="drop">
                  <template #label>
                    <div
                      style="
                        color: black;
                        flex-direction: column;
                        justify-content: start;
                        text-align: left;
                      "
                    >
                      <strong>DROP POINT </strong>
                      <div>📍🛵📦❄️ จัดส่งถึงบ้านด้วยแมสเซ็นเจอร์ที่มีกล่องเก็บอุณหภูมิ</div>
                    </div>
                  </template>
                </v-radio>
                <v-radio class="mb-3" color="primary" value="hub">
                  <template #label>
                    <div
                      style="
                        color: black;
                        flex-direction: column;
                        justify-content: start;
                        text-align: left;
                      "
                    >
                      <strong>HUB (PICK-UP)</strong>
                      <div>ฝากแช่❄️ เข้ารับตามสะดวก</div>
                    </div>
                  </template>
                </v-radio>
                <v-radio class="mb-3" color="primary" value="hub+msg">
                  <template #label>
                    <div
                      style="
                        color: black;
                        flex-direction: column;
                        justify-content: start;
                        text-align: left;
                      "
                    >
                      <strong>HUB (DELIVERY)</strong>
                      <div>ฝากแช่❄️ รอเรียกแมส (+ 🛵📦ชำระปลายทาง)</div>
                    </div>
                  </template>
                </v-radio>
                <v-radio class="mb-3" color="primary" value="express">
                  <template #label>
                    <div
                      style="
                        color: black;
                        flex-direction: column;
                        justify-content: start;
                        text-align: left;
                      "
                    >
                      <strong>EXPRESS 0-8 °c</strong>
                      <div>🚛❄️ จัดส่งควบคุมความเย็น 0-8 องศาถึงบ้านทั่วประเทศ</div>
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
              <v-divider class="my-3" />
              <div>
                <template v-if="['hub', 'hub+msg'].includes(nvbb.shippingType)">
                  <div :class="{ 'has-error': errors.has('hubLocation') }" class="mb-1">
                    <v-select
                      key="บัญชี"
                      v-model="nvbb.hubLocation"
                      v-validate="'required'"
                      outline
                      label="สถานที่รับสินค้า"
                      data-vv-as="สถานที่รับสินค้า"
                      color="primary"
                      :items="nvbb.hubLocationOptions"
                      name="hubLocation"
                      :hide-details="!errors.has('hubLocation')"
                      class="mb-2"
                      :error="errors.has('hubLocation') ? true : false"
                      :error-messages="errors.has('hubLocation') ? errors.first('hubLocation') : ''"
                    ></v-select>
                  </div>
                </template>
                <template v-else-if="nvbb.shippingType == 'drop'">
                  <div :class="{ 'has-error': errors.has('hubLocation') }" class="mb-1">
                    <v-select
                      key="บัญชี"
                      v-model="nvbb.hubLocation"
                      v-validate="'required'"
                      outline
                      label="จุดจัดส่งสินค้าถึงบ้าน"
                      data-vv-as="จุดจัดส่งสินค้าถึงบ้าน"
                      color="primary"
                      :items="nvbb.droppointLocationOptions"
                      name="hubLocation"
                      :hide-details="!errors.has('hubLocation')"
                      class="mb-2"
                      :error="errors.has('hubLocation') ? true : false"
                      :error-messages="errors.has('hubLocation') ? errors.first('hubLocation') : ''"
                    ></v-select>
                  </div>
                </template>

                <v-dialog
                  ref="dialog"
                  v-model="nvbb.showDatePicker"
                  :return-value.sync="nvbb.pickupdate"
                  persistent
                  lazy
                  full-width
                  width="290px"
                >
                  <template #activator="{ on }">
                    <v-text-field
                      v-model="nvbb.pickupdate"
                      v-validate="'required'"
                      label="วันที่รับสินค้า"
                      :data-vv-as="'วันที่รับสินค้า'"
                      prepend-inner-icon="event"
                      readonly
                      name="pickupdate"
                      :error="errors.has('pickupdate') ? true : false"
                      :hide-details="!errors.has('pickupdate')"
                      class="mb-2"
                      :error-messages="errors.has('pickupdate') ? errors.first('pickupdate') : ''"
                      outline
                      color="primary"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="nvbb.pickupdate"
                    scrollable
                    color="primary"
                    :min="mindate"
                    :allowed-dates="allowedDates"
                  >
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="nvbb.showDatePicker = false">Cancel</v-btn>
                    <v-btn flat color="primary" @click="$refs.dialog.save(nvbb.pickupdate)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </div>

              <div class="text-xs-center">
                <v-btn outline color="grey" :loading="nvbb.loading" @click="cancelMoveTo">{{
                  $t('cancel')
                }}</v-btn>
                <v-btn
                  depressed
                  color="primary"
                  :loading="nvbb.loading"
                  @click="onProceedNvbbPreorder(orderToMove)"
                  >{{ $t('Save') }}</v-btn
                >
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import mixin from './OrderSummaryItem.js'
import LoadBase64 from './LoadBase64'
import EditAddress from './EditAddress'
import TagGroup from './TagGroup'

export default {
  components: {
    'load-base64': LoadBase64,
    EditAddress: EditAddress,
    TagGroup
  },
  mixins: [mixin]
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/SummaryItem.vue